import React from 'react'
import PropTypes from 'prop-types'

import Link from '../../../../../modules/link/Link'
import { useEnvDomain } from '../../../../../hooks'

const ListItem = ({ title, url, isCrUrl, onLinkClick, activeLink = false }) => {
  const domain = useEnvDomain()

  return (
    <li className="menu-item">
      <Link
        to={isCrUrl ? `${domain}${url}` : url}
        className={`menu-item-title${activeLink ? ' active' : ''}`}
        onClick={onLinkClick}
      >
        {title}
      </Link>
    </li>
  )
}

ListItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired,
  activeLink: PropTypes.bool,
}

export default ListItem
